module.exports = __webpack_public_path__ + "static/img/技术参数BG-长.9969b65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/技术参数BG-长.png
// module id = TGrY
// module chunks = 0